import { IVideoState } from './video.types';

const videoGetters = {
  questions(state: IVideoState): any {
    return state?.videoData;
  },
};

export default videoGetters;
